import dictionaryReducer from './dictionary';
import standingReducer from './standings';
import topScorersReducer from './topScorers';
import headerInfoReducer from './headerInfo';
import calendarReducer from './calendar';
import sportsReducer from './sports';
import localStorageReducer from './localStorage';
import worldCupReducer from './worldCup';
import bettingReducer from './betting';
import reportListReducer from './reportList';
import probabiliMethodeReducer from './probabili';
import raceStandings from './raceStandings';
import internalRouterReducer from './internalRouter';

const rootReducer = {
  dictionaryReducer,
  standingReducer,
  topScorersReducer,
  headerInfoReducer,
  calendarReducer,
  sportsReducer,
  localStorageReducer,
  worldCupReducer,
  bettingReducer,
  reportListReducer,
  probabiliMethodeReducer,
  raceStandings,
  internalRouterReducer,
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js